import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { SplashScreen } from 'src/components/loading-screen';
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
import CompactLayout from 'src/layouts/compact';

const ApiCertificationPage = lazy(() => import('src/pages/apiCertification'));

export const ApiCertificationRoutes = [
  {
    path: 'api-certification',
    element: (
      <AuthGuard>
        <CompactLayout title="Api Keys" size="large">
          <RoleBasedGuard permission="BO_CAN_VIEW_B2B_CERTIFICATES">
            <Suspense fallback={<SplashScreen />}>
              <Outlet />
            </Suspense>
          </RoleBasedGuard>
        </CompactLayout>
      </AuthGuard>
    ),
    children: [{ element: <ApiCertificationPage />, index: true }],
  },
];
